// extracted by mini-css-extract-plugin
export default {"tabs":"BookmarksView_tabs__Ajg0y","card":"BookmarksView_card__RKFtk"};